const milestoneInitialColumns = [
  {
    title: 'Milestone Number',
    dataIndex: 'milestoneNumber',
    key: 'milestoneNumber',
  },
  {
    title: 'Initiative #',
    dataIndex: 'initiativeNumber',
    key: 'initiativeNumber'
  },
  {
    title: 'Milestone Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Initiative Name',
    dataIndex: 'initiativeName',
    key: 'initiativeName'
  },
  {
    title: 'Initiative Owner',
    dataIndex: 'initiativeOwnerInfo',
    key: 'initiativeOwnerInfo'
  },
  {
    title: '# - Name',
    dataIndex: 'milestoneNumber', // We'll use milestoneNumber for dataIndex and render a combined value
    key: 'milestoneNumber - name',
  },
  {
    title: 'Milestone Owner',
    dataIndex: 'Owner',
    key: 'Owner',
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'Work starting date',
  },
  {
    title: 'End Date',
    dataIndex: 'endDate',
    key: 'Milestone completion date',
  },
  {
    title: 'Status',
    dataIndex: 'Milestone Status',
    key: 'Milestone Status',
  },
  { title: 'Planning Summary', dataIndex: 'Milestone Planning summary', key: 'Milestone Planning summary' },
  { title: 'Planning summary (simplified)', dataIndex: 'Planning summary (simplified)', key: 'Planning summary (simplified)' },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Updated on',
    dataIndex: 'updatedOn',
    key: 'Updated On',
  },
  {
    title: 'Created On',
    dataIndex: 'createdOn',
    key: 'Created On',
  },
  {
    title: 'Updated by',
    dataIndex: 'updatedBy',
    key: 'Updated by',
  },
  {
    title: 'Created by',
    dataIndex: 'createdBy',
    key: 'Created by',
  },
  {
    title: 'Planning Check',
    dataIndex: 'planningCheck',
    key: 'planningCheck',
  },
  {
    title: 'Change in Milestone completion date (binned, current vs last week)',
    dataIndex: 'Change in Milestone completion date (binned, current vs last week)',
    key: 'Change in Milestone completion date (binned, current vs last week)',
  },
  {
    title: 'Initiative Accountable Workstream',
    dataIndex: 'workstreamSponsorWorkstream',
    key: 'workstreamSponsorWorkstream'
  },
  {
    title: 'Initiative Subworkstream',
    dataIndex: 'workstreamLeadSubworkstream',
    key: 'workstreamLeadSubworkstream'
  },
];
export default milestoneInitialColumns;